<template>
	<div>
		<div v-if="tandaFlag" class="employ_bar" @click="openAdd">
			<div>Add on cost</div>
			<div class="employ_bar__cost">
				<span>{{ cost ? cost : "0.00" }}%</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
				<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
				</svg>
			</div>
		</div>

		<div class="child_indexBox">
			<div class="child_nav">
				<div class="nav_top">
					<span class="cTitBox">Hours</span>
					<transition name="fade" mode="out-in">
						<i v-if="showHours" key="show" class="el-icon-arrow-up myUp_icon" @click="showHours=false"></i>
						<i v-if="!showHours" key="hidden" class="el-icon-arrow-down myUp_icon" @click="showHours=true"></i>
					</transition>
				</div>
				<el-collapse-transition>
					<div class="nav_body" v-if="showHours">
						<ul class="navBody_t">
							<li class="navBody_tit"></li>
							<li class="navBody_tit">Mon</li>
							<li class="navBody_tit">Tues</li>
							<li class="navBody_tit">Wed</li>
							<li class="navBody_tit">Thu</li>
							<li class="navBody_tit">Fri</li>
							<li class="navBody_tit">Sat</li>
							<li class="navBody_tit">Sun</li>
							<li class="navBody_tit">Total</li>
						</ul>
						<ul class="navBody_f">
							<li class="navBody_tmsg">Percentage</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageMon}}%</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageTue}}%</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageWed}}%</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageThu}}%</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageFri}}%</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageSat}}%</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageSun}}%</li>
							<li class="navBody_tmsg">{{labourHistoryHours.percentageTotal}}%</li>
						</ul>
						<ul class="navBody_f">
							<li class="navBody_tmsg">Average Hours</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgMon}}</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgTue}}</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgWed}}</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgThu}}</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgFri}}</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgSat}}</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgSun}}</li>
							<li class="navBody_tmsg">{{labourHistoryHours.avgTotal}}</li>
						</ul>
					</div>
				</el-collapse-transition>
			</div>

			<div class="child_nav">
				<div class="nav_top">
					<span class="cTitBox">Cost</span>
					<transition name="fade" mode="out-in">
						<i v-if="showCost" key="show" class="el-icon-arrow-up myUp_icon" @click="showCost=false"></i>
						<i v-else key="hidden" class="el-icon-arrow-down myUp_icon" @click="showCost=true"></i>
					</transition>
				</div>
				<el-collapse-transition>
					<div class="nav_body" v-show="showCost">
						<ul class="navBody_t">
							<li class="navBody_tit"></li>
							<li class="navBody_tit">Mon</li>
							<li class="navBody_tit">Tues</li>
							<li class="navBody_tit">Wed</li>
							<li class="navBody_tit">Thu</li>
							<li class="navBody_tit">Fri</li>
							<li class="navBody_tit">Sat</li>
							<li class="navBody_tit">Sun</li>
							<li class="navBody_tit">Total</li>
						</ul>
						<ul class="navBody_f">
							<li class="navBody_tmsg">Percentage</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageMon}}%</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageTue}}%</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageWed}}%</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageThu}}%</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageFri}}%</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageSat}}%</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageSun}}%</li>
							<li class="navBody_tmsg">{{labourHistoryCost.percentageTotal}}%</li>
						</ul>
						<ul class="navBody_f">
							<li class="navBody_tmsg">Average Cost</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgMon}}</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgTue}}</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgWed}}</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgThu}}</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgFri}}</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgSat}}</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgSun}}</li>
							<li class="navBody_tmsg">${{labourHistoryCost.avgTotal}}</li>
						</ul>
					</div>
				</el-collapse-transition>
			</div>

			
			<el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
				<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
			</el-dialog>

			<el-dialog
				title="Add on Cost"
				:visible.sync="extraDio"
				:modal-append-to-body="false"
				:show-close="false"
				class="editCardDio"
				:close-on-click-modal="false"
				width="840px"
				center
			>
				<div>
				<div class="tag_tit_new">Add on Cost</div>
				<el-input
					v-model="costValue"
					maxlength="6"
					class="borderNone"
					@input="handleCostInput"
				>
					<span slot="suffix" class="increaseIcon_new">%</span>
				</el-input>
				</div>
				<span slot="footer" class="dialog-footer">
				<el-button
					@click="(extraDio = false), (costValue = '')"
					class="cardCanBtn"
					>Cancel</el-button
				>
				<el-button class="cardConBtn" @click="confirmUpdateCost"
					>Confirm</el-button
				>
				</span>
			</el-dialog>

		</div>
	</div>
</template>

<script>
import api from '../../api/api'
import freeTrialNotice from '@/components/modal/freeTrialNotice';
import Utils from '../../utils/utils';
export default {
	data() {
		return {
			showHours:true,
			showCost:true,
			labourHistoryHours:{
				avgFri:'0.00',
				avgMon:'0.00',
				avgSat:'0.00',
				avgSun:'0.00',
				avgThu:'0.00',
				avgTue:'0.00',
				avgWed:'0.00',
				avgTotal:'0.00',
				percentageFri:'0.00',
				percentageMon:'0.00',
				percentageSat:'0.00',
				percentageSun:'0.00',
				percentageThu:'0.00',
				percentageTotal:'0.00',
				percentageTue:'0.00',
				percentageWed:'0.00',
			},
			labourHistoryCost:{
				avgFri:'0.00',
				avgMon:'0.00',
				avgSat:'0.00',
				avgSun:'0.00',
				avgThu:'0.00',
				avgTue:'0.00',
				avgWed:'0.00',
				avgTotal:'0.00',
				percentageFri:'0.00',
				percentageMon:'0.00',
				percentageSat:'0.00',
				percentageSun:'0.00',
				percentageThu:'0.00',
				percentageTotal:'0.00',
				percentageTue:'0.00',
				percentageWed:'0.00',
			},
			cost: 0,
			isPro: false,
			isDoneLoad: false,
			venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
			updating: false,
			extraDio: false,
			costValue: '',
			tandaFlag: false,
		}
	},
	props:['time'],
	mounted () {
		this.getlist()

		this.$root.$on('isPro', (isPro, others) => { 
			this.isPro = isPro
			this.isDoneLoad = true

			const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}

			this.tandaFlag = others.tandaFlag
		})

		api.onCostV2({
			callback: (res) => {
				let { code, data, message } = res.data;
				if (code == 0 && data) {
					this.cost = data != 'null' ? data : 0;
				}
			},
		});
	},
	methods: {
		openAdd() {
			this.extraDio = true
			this.costValue = this.cost
		},
		handleCostInput() {
			// Allow digits, decimal point, and negative sign
			let value = this.costValue.replace(/[^\d.-]/g, '');
			
			// Handle negative sign - only allow at the beginning
			if (value.includes('-')) {
				const negativeIndex = value.indexOf('-');
				if (negativeIndex !== 0) {
					value = value.replace(/-/g, '');
				} else {
					// Keep only the first negative sign
					value = '-' + value.substring(1).replace(/-/g, '');
				}
			}
			
			// Handle decimal point - only allow one
			const decimalCount = (value.match(/\./g) || []).length;
			if (decimalCount > 1) {
				const firstDecimalIndex = value.indexOf('.');
				value = value.substring(0, firstDecimalIndex + 1) + value.substring(firstDecimalIndex + 1).replace(/\./g, '');
			}
			
			// Prevent multiple leading zeros (except for 0.xx)
			if (value.match(/^0\d/) && !value.match(/^0\./)) {
				value = value.substring(1);
			}
			
			// Limit to 2 decimal places
			if (value.includes('.')) {
				const parts = value.split('.');
				if (parts[1] && parts[1].length > 2) {
					value = parts[0] + '.' + parts[1].substring(0, 2);
				}
			}
			
			// Check if value exceeds 100 (or -100 for negative values)
			const numericValue = parseFloat(value);
			if (!isNaN(numericValue) && Math.abs(numericValue) >= 100) {
				value = '';
			}
			
			this.costValue = value;
		},
		confirmUpdateCost() {
			if (this.updating) return;

			this.updating = true;
			
			api.updateCostV2({
				params: this.costValue,
				callback: (res) => {
					let { code, data, message } = res.data;
					this.updating = false;
					this.extraDio = false;
					
					if (code == 0) {
						this.cost = this.costValue;
					} else {
						Utils.alert2("", message, "error");
					}
				},
			});
		},
		getlist(){
			api.getLabourHistory('',res=>{
                let {code,data,message}=res.data;
                if(code==0){
					this.labourHistoryCost = data.labourHistoryCost
					this.labourHistoryCost.avgFri = Utils.formatSplit(Number(this.labourHistoryCost.avgFri))
					this.labourHistoryCost.avgMon = Utils.formatSplit(Number(this.labourHistoryCost.avgMon))
					this.labourHistoryCost.avgSat = Utils.formatSplit(Number(this.labourHistoryCost.avgSat))
					this.labourHistoryCost.avgSun = Utils.formatSplit(Number(this.labourHistoryCost.avgSun))
					this.labourHistoryCost.avgThu = Utils.formatSplit(Number(this.labourHistoryCost.avgThu))
					this.labourHistoryCost.avgTue = Utils.formatSplit(Number(this.labourHistoryCost.avgTue))
					this.labourHistoryCost.avgWed = Utils.formatSplit(Number(this.labourHistoryCost.avgWed))
					this.labourHistoryCost.avgTotal = Utils.formatSplit(Number(this.labourHistoryCost.avgTotal))
					this.labourHistoryCost.percentageFri = Utils.formatSplit(Number(this.labourHistoryCost.percentageFri))
					this.labourHistoryCost.percentageMon = Utils.formatSplit(Number(this.labourHistoryCost.percentageMon))
					this.labourHistoryCost.percentageSat = Utils.formatSplit(Number(this.labourHistoryCost.percentageSat))
					this.labourHistoryCost.percentageSun = Utils.formatSplit(Number(this.labourHistoryCost.percentageSun))
					this.labourHistoryCost.percentageThu = Utils.formatSplit(Number(this.labourHistoryCost.percentageThu))
					this.labourHistoryCost.percentageTotal = Utils.formatSplit(Number(this.labourHistoryCost.percentageTotal))
					this.labourHistoryCost.percentageTue = Utils.formatSplit(Number(this.labourHistoryCost.percentageTue))
					this.labourHistoryCost.percentageWed = Utils.formatSplit(Number(this.labourHistoryCost.percentageWed))
					// 
					this.labourHistoryHours = data.labourHistoryHours
					this.labourHistoryHours.avgFri = Utils.formatSplit(Number(this.labourHistoryHours.avgFri))
					this.labourHistoryHours.avgMon = Utils.formatSplit(Number(this.labourHistoryHours.avgMon))
					this.labourHistoryHours.avgSat = Utils.formatSplit(Number(this.labourHistoryHours.avgSat))
					this.labourHistoryHours.avgSun = Utils.formatSplit(Number(this.labourHistoryHours.avgSun))
					this.labourHistoryHours.avgThu = Utils.formatSplit(Number(this.labourHistoryHours.avgThu))
					this.labourHistoryHours.avgTue = Utils.formatSplit(Number(this.labourHistoryHours.avgTue))
					this.labourHistoryHours.avgWed = Utils.formatSplit(Number(this.labourHistoryHours.avgWed))
					this.labourHistoryHours.avgTotal = Utils.formatSplit(Number(this.labourHistoryHours.avgTotal))
					this.labourHistoryHours.percentageFri = Utils.formatSplit(Number(this.labourHistoryHours.percentageFri))
					this.labourHistoryHours.percentageMon = Utils.formatSplit(Number(this.labourHistoryHours.percentageMon))
					this.labourHistoryHours.percentageSat = Utils.formatSplit(Number(this.labourHistoryHours.percentageSat))
					this.labourHistoryHours.percentageSun = Utils.formatSplit(Number(this.labourHistoryHours.percentageSun))
					this.labourHistoryHours.percentageThu = Utils.formatSplit(Number(this.labourHistoryHours.percentageThu))
					this.labourHistoryHours.percentageTotal = Utils.formatSplit(Number(this.labourHistoryHours.percentageTotal))
					this.labourHistoryHours.percentageTue = Utils.formatSplit(Number(this.labourHistoryHours.percentageTue))
					this.labourHistoryHours.percentageWed = Utils.formatSplit(Number(this.labourHistoryHours.percentageWed))
                }else{
                    Utils.alert('',message,'error')
                }
            })
		},

		closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		}
	},

	components: {
		freeTrialNotice: freeTrialNotice
	}
}
</script>

<style lang="scss" scoped>
	.tag_tit_new {
		height: 16px;
		font-size: 14px;
		font-weight: 400;
		color: var(--text-color);
		line-height: 16px;
		margin: 10px 0 20px 0;
	}
	.increaseIcon_new {
		font-size: 22px;
		line-height: 50px;
		margin-right: 5px;
	}
	.employ_bar {
		width: 100%;
		height: 70px;
		background: var(--background-color-3);
		margin-top: 35px;
		padding-left: 35px;
		box-sizing: border-box;
		width: 100%;
		font-size: 20px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: var(--text-color);
		line-height: 70px;
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		align-content: center;
		&__cost {
			padding: 0px 20px;
			color: var(--text-color);
			display: flex;
			align-items: center;
			align-content: center;
			gap: 30px;
		}

	}
	.child_indexBox{
		width: 100%;
		margin-top: 30px;
		.child_nav{
			background-color: var(--background-color-3);
			margin-bottom: 30px;
			.nav_top{
				box-sizing: border-box;
				padding:21px 30px;
				display: flex;
				.cTitBox{
					height:28px;
					font-size:20px;
					font-family:PingFang SC;
					font-weight:600;
					color:var(--text-color);
					line-height:28px;
				}
				.myUp_icon{
					font-size:20px;
					color: var(--text-color);
					margin-left: auto;
					cursor: pointer;
				}
			}
			.nav_body{
				.navBody_t{
					display: flex;
					height: 50px;
					justify-content: center;
					align-items: center;
					border:  1px solid #5c5c5d !important;
					.navBody_tit{
						flex: 1;
						height:22px;
						font-size:16px;
						font-weight:600;
						color:var(--text-color);
						line-height:22px;
						text-align: center;
					}
				}
				.navBody_f{
					display: flex;
					height: 60px;
					justify-content: center;
					align-items: center;
					border-bottom:  1px solid #5c5c5d !important;
					.navBody_tmsg{
						flex: 1;
						height:100%;
						font-size:18px;
						font-weight:500;
						color:var(--text-color);
						line-height:60px;
						text-align: center;
						border-left:  1px solid #5c5c5d !important;
						&:last-child{
							border-right:  1px solid #5c5c5d !important;
						}
					}
				}
			}
		}
		padding-bottom: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/components/rosterAndLabour/labour.vue